(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.product-qty-stepper').forEach(function(stepper) {
    var input = stepper.querySelector('[data-qty-input]');
    stepper.querySelector('[data-qty-minus]').addEventListener('click', function() {
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    stepper.querySelector('[data-qty-plus]').addEventListener('click', function() {
      input.value = parseInt(input.value, 10) + 1;
    });
  });
  // Update product image when colour/variant changes
  (function() {
    function updateVariantImage(event) {
      var variant = event.detail && event.detail.variant;
      var section = event.target && event.target.closest('[data-section-type="product"]');
      if (!section || !variant) return;

      var mediaId = variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;

      var thumbnailLink = section.querySelector('[data-thumbnail-media-id="' + mediaId + '"]');
      if (!thumbnailLink) return;

      // Use jQuery pseudoclick to match the theme's selectThumbnailImage handler
      if (typeof jQuery !== 'undefined') {
        jQuery(thumbnailLink).trigger('pseudoclick');
      } else {
        thumbnailLink.click();
      }
    }

    document.addEventListener('on:variant:change', updateVariantImage);
  })();
    // Filter out service products from complementary/recommended products sections
  (function() {
    function filterServiceProductsFromComplementary() {
      var serviceKeywords = ['installation service', 'removal', 'recycling', 'delivery service'];
      
      // Find all product blocks in complementary and product recommendation sections
      var allProductBlocks = document.querySelectorAll(
        '.cc-fetched-content .swiper-slide, ' +
        '.cc-fetched-content .row-half-space, ' +
        '.product-recommendations .product-block, ' +
        '[data-dynamic-product-content] .product-block'
      );
      
      allProductBlocks.forEach(function(block) {
        var titleElement = block.querySelector('.product-block__title, h3, a[href*="/products/"]');
        
        if (!titleElement) return;
        
        var productTitle = titleElement.textContent.toLowerCase();
        var isService = serviceKeywords.some(function(keyword) {
          return productTitle.includes(keyword);
        });
        
        if (isService) {
        
          var parent = block.closest('.swiper-slide') || block.closest('.row-half-space') || block;
          parent.remove();
        }
      });
    }

   
    filterServiceProductsFromComplementary();

  
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          setTimeout(filterServiceProductsFromComplementary, 100);
        }
      });
    });

    var targetElement = document.querySelector('cc-fetched-content') || document.body;
    observer.observe(targetElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');
  function filterServiceProducts() {
   
    const productBlocks = document.querySelectorAll('.product-recommendations .product-block');
    productBlocks.forEach((block) => {
      const productLink = block.querySelector('[data-product-id]');
      const productTitle = block.querySelector('.product-block__title, h3, a');
      
      if (!productLink && !productTitle) return;
      
    
      const title = productTitle ? productTitle.textContent.toLowerCase() : '';
      const serviceKeywords = ['installation service', 'removal', 'recycling', 'delivery service'];
      
      const isService = serviceKeywords.some(keyword => title.includes(keyword));
      
      if (isService) {
        block.remove();
      }
    });
  }
  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
